import { emptyValidationResponse } from '../urlValidationUtils'

const CanvaValidator = (url: string) => {
  let regexGroups

  // First attempt
  regexGroups = /(?:https:\/\/)?(?:www.)?canva.com\/design\/([\w\-_/?=&]+)/.exec(url)
  if (!regexGroups?.[1])
    regexGroups =
      /(?:https:\/\/)?(?:\/\/|(?:&#x2F;&#x2F;))(?:www.)?canva.com(?:\/|(?:&#x2F;))design(?:\/|(?:&#x2F;))([\w\-_/?=&]+)/.exec(
        url,
      )

  if (regexGroups?.[1]) {
    const validUrl = new URL(`https://canva.com/design/${regexGroups?.[1]}`)
    validUrl.searchParams.set('embed', 'true')

    return {
      validUrl: validUrl.href,
      isEmbeddable: true,
    }
  }

  return emptyValidationResponse
}

export default CanvaValidator
